module.exports = __webpack_public_path__ + "static/media/hp-section-02.d45dea1e.jpg";